
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommOrderItemsGrid extends Serenity.EntityGrid<ECommOrderItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderItems'; }
        protected getDialogType() { return ECommOrderItemsDialog; }
        protected getIdProperty() { return ECommOrderItemsRow.idProperty; }
        protected getInsertPermission() { return ECommOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommOrderItemsRow.localTextPrefix; }
        protected getService() { return ECommOrderItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        
    } 
} 